module.exports = "https://www.gc-qa.gnp.com.mx/fece0772ec787ff45d067b002d650df0.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/pin-map.png
// module id = 987
// module chunks = 0 1